import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RequestCorrelationService {
  #lastTraceId: string | null = null;

  // "Last" is approximate with parallel requests in flight: only a runtime error needs it, having no request
  // of its own — an http error always reads the trace id off the request that failed.
  lastTraceId(): string | null {
    return this.#lastTraceId;
  }

  rememberTraceId(traceId: string): void {
    this.#lastTraceId = traceId;
  }
}
